import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";
import TermsCheckbox from "../../ui-library/AuthControls/TermsCheckbox";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Subtitle = styled.p`
  color: ${(props) => props.theme?.nero};
  margin-bottom: 2rem;
  text-align: justify;
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 38px;
  @media (max-width: 576px) {
    padding-top: 2rem;
    margin-top: auto;
    .btn {
      width: 100%;
    }
  }
`;

const Notice = (props) => {
  const { accountUsername, email, handleAcceptedTerms, closeModalGoHome } =
    props;

  const { t } = useTranslation();

  const [checked, setChecked] = useState(false);

  const onCheckboxChange = (value) => {
    setChecked(value);
  };

  const onAcceptTerms = (event) => {
    event.preventDefault();
    const agreement = checked;
    const username = email || accountUsername;
    handleAcceptedTerms(username, agreement).then(() => {
      closeModalGoHome();
    });
  };

  return (
    <Container data-testid="notice-view">
      <form
        onSubmit={onAcceptTerms}
        className="auth-form"
        data-testid="notice-form"
      >
        <Subtitle
          dangerouslySetInnerHTML={{
            __html: t("contentText.privacyPolicy.notice.message", {
              link: "Ultragenyx.com",
            }),
          }}
        />

        <TermsCheckbox
          policyHref="https://www.ultragenyx.com/privacy-policy/"
          onChange={onCheckboxChange}
        />
        <ActionButtonsContainer>
          <PrimaryButton
            text={t("appText.confirm")}
            type="submit"
            disabled={!checked}
          />
        </ActionButtonsContainer>
      </form>
    </Container>
  );
};

export default withTheme(Notice);
